import { enableParental, userSelector } from '@shared/store/slices/user.slice';
import { useAppDispatch, useAppSelector } from '@shared/store/hooks';
import { useEffect } from 'react';

const CHECK_PARENTAL_TIME = 60 * 60 * 1000;

// Enable parental control one hour after disabling it

export default function useParental() {
  const dispatch = useAppDispatch();
  const { parental } = useAppSelector(userSelector);

  useEffect(() => {
    if (parental?.enabled === false) {
      setTimeout(() => {
        dispatch(enableParental());
      }, CHECK_PARENTAL_TIME);
    }
  }, [parental?.enabled]);

  return null;
}
